import { css } from "styled-components";

const font = {
  tA: css`
    font-family: MBC 1961Gulim OTF;
    font-size: 85px;
    font-weight: 400;
    line-height: 98px;
    letter-spacing: -0.03em;
    text-align: center;
  `,
  t1: css`
    font-family: Pretendard;
    font-size: 32px;
    font-weight: 600;
    line-height: 46px;
    letter-spacing: -0.03em;
    text-align: center;
  `,
  t2: css`
    font-family: Pretendard;
    font-size: 24px;
    font-weight: 600;
    line-height: 35px;
    letter-spacing: -0.03em;
    text-align: left;
  `,
  t3: css`
    font-family: Pretendard;
    font-size: 24px;
    font-weight: 500;
    line-height: 35px;
    letter-spacing: -0.03em;
    text-align: left;
  `,
  t4: css`
    font-family: Pretendard;
    font-size: 22px;
    font-weight: 600;
    line-height: 32px;
    letter-spacing: -0.03em;
    text-align: center;
  `,
  t5: css`
    font-family: Pretendard;
    font-size: 22px;
    font-weight: 500;
    line-height: 32px;
    letter-spacing: -0.03em;
    text-align: center;
  `,
  t6: css`
    font-family: Pretendard;
    font-size: 19px;
    font-weight: 600;
    line-height: 29px;
    letter-spacing: -0.03em;
    text-align: center;
  `,
  t7: css`
    font-family: Pretendard;
    font-size: 19px;
    font-weight: 500;
    line-height: 29px;
    letter-spacing: -0.03em;
    text-align: center;
  `,
};

export default font;
